(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-product-high-variant"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('product-form:cart:navigate', (event) => {
    theme.settings.cartType !== 'page' && event.preventDefault();
  });

  document.addEventListener('product-form:submit:success', () => {
    document.dispatchEvent(new CustomEvent('ajaxProduct:added'));
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shoppable-hero"] && !Shopify.designMode) return;
  try {
    
  class KitShoppableHero extends HTMLElement {
    connectedCallback() {
      this.abortController = new AbortController();
      const signal = this.abortController.signal;

      if (window.theme && window.theme.sections) {
        this.initQuickShop();
      } else {
        document.addEventListener('page:loaded', () => this.initQuickShop(), { once: true, signal });
      }

      if (this.querySelector('kit-popover')) {
        window.addEventListener('scroll', () => {
          this.querySelectorAll('kit-popover:popover-open').forEach(p => p.hidePopover());
        }, { passive: true, signal });
      }

      if (!Shopify.designMode) return;

      document.addEventListener('shopify:section:load', (event) => {
        if (event.target.contains(this)) {
          this.initQuickShop();
        }
      }, { signal });

      this.addEventListener('shopify:block:select', (event) => {
        this.initQuickShop();
        const btn = event.target.querySelector('button');
        if (btn) btn.click();
      }, { signal });

      this.addEventListener('shopify:block:deselect', (event) => {
        const popover = event.target.querySelector('kit-popover');
        if (popover) popover.hidePopover?.();
      }, { signal });
    }

    disconnectedCallback() {
      this.abortController?.abort();
    }

    initQuickShop() {
      if (!theme.settings.quickView) return;

      var sectionEl = this.closest('[id^="shopify-section-"]');
      var links = this.querySelectorAll('.shoppable-hero__popover-link[data-product-handle]');
      if (!links.length) return;

      links.forEach(link => {
        if (link.dataset.shoppableHeroBound === 'true') return;
        link.dataset.shoppableHeroBound = 'true';

        var handle = link.dataset.productHandle;
        var productId = link.dataset.productId;

        if (!document.getElementById('QuickShopModal-' + productId)) return;

        // Capture-phase interceptor registered before modal binds its handler.
        // On mobile, blocks the modal handler so the link navigates normally.
        link.addEventListener('click', (event) => {
          if (theme.config.bpSmall) {
            event.stopImmediatePropagation();
            return;
          }
          const popover = event.target.closest('kit-popover');
          if (popover) popover.hidePopover?.();
        }, true);

        var hotspot = link.closest('.kit-shoppable-hero__hotspot');
        if (!hotspot) return;

        var preloadOnce = function() {
          if (link.dataset.shoppableHeroPreloaded === 'true') return;
          if (theme.config.bpSmall) return;

          // If a holder already exists from another section (e.g. product grid),
          // remove our duplicate modal shell to avoid duplicate IDs
          var holder = document.getElementById('QuickShopHolder-' + handle);
          if (holder && sectionEl) {
            var holderSection = holder.closest('[id^="shopify-section-"]');
            if (holderSection && holderSection !== sectionEl) {
              var duplicate = sectionEl.querySelector('#QuickShopModal-' + productId);
              if (duplicate) duplicate.remove();
            }
          }

          link.dataset.shoppableHeroPreloaded = 'true';
          link.classList.add('js-modal-open-quick-modal-' + productId);
          theme.preloadProductModal(handle, productId, link);

          hotspot.removeEventListener('mouseover', preloadOnce);
          hotspot.removeEventListener('focusin', preloadOnce);
        };

        hotspot.addEventListener('mouseover', preloadOnce);
        hotspot.addEventListener('focusin', preloadOnce);
      });
    }
  }

  customElements.define('kit-shoppable-hero', KitShoppableHero);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sm-dest-hero"] && !Shopify.designMode) return;
  try {
    
  /**
   * "Start packing" glides down to the packing list instead of jumping, so
   * it reads as the same page (Alex: the instant jump felt like a page
   * change). Duration grows with distance, 0.7-1.4s; any wheel or touch
   * stops it; reduced motion jumps straight there. The list gets focus
   * at the end for keyboard and screen-reader users.
   */
  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[data-glide][href^="#"]');
    if (!link) return;
    const target = document.getElementById(link.getAttribute('href').slice(1));
    if (!target) return;
    event.preventDefault();

    const startY = window.scrollY;
    const endY = target.getBoundingClientRect().top + startY - 12;
    const distance = endY - startY;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const duration = reduce ? 0 : Math.min(1400, Math.max(700, Math.abs(distance) * 0.45));
    const ease = (t) => (t < 0.5 ? 4 * t * t * t : 1 - Math.pow(-2 * t + 2, 3) / 2);

    const finish = () => {
      if (!target.hasAttribute('tabindex')) target.setAttribute('tabindex', '-1');
      target.focus({ preventScroll: true });
    };
    if (!duration) {
      window.scrollTo({ top: endY, behavior: 'instant' });
      finish();
      return;
    }

    let stopped = false;
    const stop = () => {
      stopped = true;
    };
    window.addEventListener('wheel', stop, { once: true, passive: true });
    window.addEventListener('touchstart', stop, { once: true, passive: true });
    const start = performance.now();
    const step = (now) => {
      if (stopped) return;
      const t = Math.min((now - start) / duration, 1);
      window.scrollTo({ top: startY + distance * ease(t), behavior: 'instant' });
      if (t < 1) {
        requestAnimationFrame(step);
        return;
      }
      window.removeEventListener('wheel', stop);
      window.removeEventListener('touchstart', stop);
      finish();
    };
    requestAnimationFrame(step);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sm-dest-looks"] && !Shopify.designMode) return;
  try {
    
  /**
   * Looks: tap a piece to add it from a slide-up sheet, without leaving
   * the page. One <dialog> holds a panel per piece; one is shown at a time.
   * The button walks the look: Add to bag, then "Next: <piece>" for each
   * piece not yet in the bag, and after the last one the sheet closes and
   * the cart drawer opens. "Read more" swaps in the full description;
   * "Size chart" opens the product's Kiwi chart over the sheet.
   */
  class SmLookShop extends HTMLElement {
    #variants = {};
    #sheet = null;
    #active = null;
    #mode = 'add';
    #nextKey = null;
    #inBag = new Set();
    #busy = false;
    #kiwi = {};
    #kiwiObserver = null;
    #charts = new WeakMap();
    #kiwiReady = null;
    #nearby = null;
    #panelsReady = false;

    connectedCallback() {
      try {
        // Compact JSON (snippets/sm-dest-variants-json.liquid): each photo
        // once per product, variants point at it by index; expand to img.
        const raw = JSON.parse(this.querySelector('[data-look-variants]')?.textContent || '{}');
        this.#variants = Object.fromEntries(Object.entries(raw).map(([id, product]) => [
          id, (product.v || []).map((v) => ({ ...v, img: product.imgs?.[v.i] ?? null })),
        ]));
      } catch (error) {
        this.#variants = {};
      }
      try {
        this.#kiwi = JSON.parse(this.querySelector('[data-look-kiwi]')?.textContent || '{}');
      } catch (error) {
        this.#kiwi = {};
      }
      this.#sheet = this.querySelector('[data-qa]');
      this.addEventListener('click', this.#onClick);
      this.addEventListener('change', this.#onChange);
      this.#sheet?.addEventListener('close', this.#onClose);
      this.#sheet?.addEventListener('cancel', this.#onCancel);
      this.#nearby = new IntersectionObserver((entries) => {
        if (!entries.some((entry) => entry.isIntersecting)) return;
        this.#nearby.disconnect();
        // On phones the looks are within 600px from the start, so wait for
        // the page to finish loading and the browser to go idle before
        // building the panels and preloading charts; a tap builds them
        // at once (#open).
        const start = () => (window.requestIdleCallback || setTimeout)(() => {
          this.#ensurePanels();
          this.#preloadCharts();
        });
        if (document.readyState === 'complete') start();
        else window.addEventListener('load', start, { once: true });
      }, { rootMargin: '600px 0px' });
      this.#nearby.observe(this);
    }

    disconnectedCallback() {
      this.#nearby?.disconnect();
      this.removeEventListener('click', this.#onClick);
      this.removeEventListener('change', this.#onChange);
      this.#sheet?.removeEventListener('close', this.#onClose);
      this.#sheet?.removeEventListener('cancel', this.#onCancel);
      document.documentElement.classList.remove('sm-dest-sheet-open');
    }

    #onClick = (event) => {
      const target = event.target;
      if (target === this.#sheet || target.closest('[data-qa-close]')) {
        this.#closeSheet();
        return;
      }
      const open = target.closest('[data-piece-open]');
      if (open) {
        this.#open(open.dataset.pieceOpen);
        return;
      }
      if (target.closest('[data-qa-read]')) {
        this.#reading(true);
        return;
      }
      if (target.closest('[data-qa-back]')) {
        this.#reading(false);
        return;
      }
      if (target.closest('[data-size-chart]')) {
        this.#openChart();
        return;
      }
      if (target.closest('[data-qa-primary]')) {
        if (this.#mode === 'next' && this.#nextKey) this.#open(this.#nextKey);
        else if (this.#mode === 'add') this.#add();
      }
    };

    #onChange = (event) => {
      const panel = event.target.closest('[data-qa-panel]');
      if (!panel) return;
      this.#setMode('add');
      this.#sync(panel);
    };

    /**
     * Closes with a slide-down instead of vanishing (motion pass,
     * 2026-09-23). Escape is routed here through the cancel event so it
     * animates too. Reduced motion closes at once.
     */
    #closeSheet() {
      const sheet = this.#sheet;
      if (!sheet?.open || sheet.classList.contains('is-closing')) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        sheet.close();
        return;
      }
      sheet.classList.add('is-closing');
      let done = false;
      const finish = (event) => {
        if (done || (event && event.target !== sheet)) return;
        done = true;
        sheet.removeEventListener('animationend', finish);
        sheet.classList.remove('is-closing');
        sheet.close();
      };
      sheet.addEventListener('animationend', finish);
      setTimeout(() => finish(), 400);
    }

    #onCancel = (event) => {
      event.preventDefault();
      this.#closeSheet();
    };

    #onClose = () => {
      document.documentElement.classList.remove('sm-dest-sheet-open');
      this.#kiwiObserver?.disconnect();
      this.#kiwiObserver = null;
      this.querySelector(`[data-piece-open="${this.#active}"]`)?.focus({ preventScroll: true });
    };

    #panel() {
      return this.querySelector(`[data-qa-panel="${this.#active}"]`);
    }

    #lookPanels(panel) {
      return [...this.querySelectorAll(`[data-qa-panel][data-look-id="${panel.dataset.lookId}"]`)];
    }

    /** Builds the pieces' panels from their template, once, and syncs them. */
    #ensurePanels() {
      if (this.#panelsReady) return;
      this.#panelsReady = true;
      const template = this.querySelector('template[data-qa-panels]');
      if (!template) return;
      template.replaceWith(template.content.cloneNode(true));
      for (const panel of this.querySelectorAll('[data-qa-panel]')) {
        this.#sync(panel);
        if (this.#kiwi[panel.dataset.id]) panel.querySelector('[data-size-chart]')?.removeAttribute('hidden');
      }
    }

    #open(key) {
      this.#ensurePanels();
      const panel = this.querySelector(`[data-qa-panel="${key}"]`);
      if (!panel || !this.#sheet) return;
      const switching = this.#sheet.open && this.#active !== key;
      this.#active = key;
      for (const other of this.querySelectorAll('[data-qa-panel]')) other.hidden = other !== panel;
      if (switching) {
        panel.classList.remove('is-entering');
        void panel.offsetWidth;
        panel.classList.add('is-entering');
      }
      this.querySelector('[data-qa-look]').textContent = panel.dataset.lookLine;
      this.#sheet.setAttribute('aria-labelledby', `SmDestQaName-${key}`);
      this.querySelector('[data-qa-error]').textContent = '';
      this.querySelector('[data-qa-done]').textContent = '';
      this.#setMode('add');
      this.#reading(false);
      this.#progress(panel);
      this.#sync(panel);
      if (!this.#sheet.open) {
        this.#sheet.showModal();
        document.documentElement.classList.add('sm-dest-sheet-open');
      }
      this.querySelector('[data-qa-body]').scrollTop = 0;
      if (switching) {
        const open = [...panel.querySelectorAll('[data-option]')].find((f) => !f.querySelector('input:checked'));
        (open?.querySelector('input:not(:disabled)') || this.querySelector('[data-qa-close]')).focus({ preventScroll: true });
      }
      this.#loadChart(panel);
    }

    /** Swaps the panel between its options and its full description. */
    #reading(on) {
      const panel = this.#panel();
      const view = panel?.querySelector('[data-qa-read-view]');
      if (!view) {
        this.#sheet.classList.remove('is-reading');
        this.querySelector('.sm-dest-qa__foot').hidden = false;
        return;
      }
      const wasOn = !view.hidden;
      view.hidden = !on;
      this.#sheet.classList.toggle('is-reading', on);
      panel.querySelector('[data-qa-main]').hidden = on;
      this.querySelector('.sm-dest-qa__foot').hidden = on;
      this.querySelector('[data-qa-body]').scrollTop = 0;
      if (on) view.querySelector('[data-qa-back]').focus();
      else if (wasOn) panel.querySelector('[data-qa-read]')?.focus();
    }

    /**
     * Kiwi Size Chart, loaded the way its product-page block does it (set
     * window.KiwiSizing.data, call loadKiwiSizingChart) with each piece's
     * data. Kiwi injects its own "Size Chart" link next to the hidden host;
     * ours clicks it. Charts load in the background as soon as the looks
     * come near the screen (Alex: the button appearing a second after the
     * sheet opened looked broken), one piece at a time because Kiwi reads
     * the global data. Resolves true once the link exists; a piece that
     * gets no chart within 8s hides its button.
     */
    #loadChart(panel) {
      if (this.#charts.has(panel)) return this.#charts.get(panel);
      const promise = new Promise((resolve) => {
        const data = this.#kiwi[panel.dataset.id];
        const host = panel.querySelector('[data-qa-kiwi]');
        if (!data || !host) {
          resolve(false);
          return;
        }
        const has = () => Boolean(panel.querySelector('.ks-chart-modal-link'));
        this.#whenKiwi().then((ok) => {
          if (!ok) {
            resolve(false);
            return;
          }
          const observer = new MutationObserver(() => {
            if (!has()) return;
            observer.disconnect();
            resolve(true);
          });
          observer.observe(panel, { childList: true, subtree: true });
          setTimeout(() => {
            observer.disconnect();
            resolve(has());
          }, 8000);
          window.KiwiSizing = window.KiwiSizing || {};
          window.KiwiSizing.shop = window.KiwiSizing.shop || this.dataset.shop;
          window.KiwiSizing.data = data;
          window.loadKiwiSizingChart({ el: host });
        });
      });
      promise.then((ok) => {
        const button = panel.querySelector('[data-size-chart]');
        if (button) button.hidden = !ok;
      });
      this.#charts.set(panel, promise);
      return promise;
    }

    /** Kiwi's plugin loads on its own schedule; wait up to 15s for it. */
    #whenKiwi() {
      this.#kiwiReady ??= new Promise((resolve) => {
        let tries = 0;
        const check = () => {
          if (typeof window.loadKiwiSizingChart === 'function') resolve(true);
          else if ((tries += 1) > 60) resolve(false);
          else setTimeout(check, 250);
        };
        check();
      });
      return this.#kiwiReady;
    }

    async #preloadCharts() {
      const idle = () => new Promise((resolve) => (window.requestIdleCallback || setTimeout)(resolve));
      for (const panel of this.querySelectorAll('[data-qa-panel]')) {
        await idle();
        await this.#loadChart(panel);
      }
    }

    /**
     * Kiwi appends its modal to <body>, which sits under this modal
     * <dialog> (the top layer), so it opens behind the sheet. Moving it
     * into the dialog while the sheet is open puts it on top; Kiwi's own
     * close still works because it holds references, not selectors.
     */
    async #openChart() {
      const panel = this.#panel();
      const button = panel?.querySelector('[data-size-chart]');
      if (!panel || !button || button.classList.contains('is-loading')) return;
      button.classList.add('is-loading');
      const ok = await this.#loadChart(panel);
      button.classList.remove('is-loading');
      const link = panel.querySelector('.ks-chart-modal-link');
      if (!ok || !link || panel !== this.#panel() || !this.#sheet.open) return;
      const adopt = () => {
        for (const el of document.querySelectorAll('body > .ks-modal-backdrop, body > .kiwi-sizing-modal')) {
          this.#sheet.append(el);
        }
      };
      if (!this.#kiwiObserver) {
        this.#kiwiObserver = new MutationObserver(adopt);
        this.#kiwiObserver.observe(document.body, { childList: true });
      }
      link.click();
      adopt();
    }

    #progress(panel) {
      const pieces = this.#lookPanels(panel);
      const done = pieces.filter((p) => this.#inBag.has(p.dataset.qaPanel)).length;
      const label = this.querySelector('[data-qa-progress]');
      label.textContent = pieces.length > 1
        ? (this.dataset.progressLabel || '').replace('[done]', done).replace('[total]', pieces.length)
        : '';
    }

    #setMode(mode, nextPanel) {
      this.#mode = mode;
      this.#nextKey = nextPanel?.dataset.qaPanel ?? null;
      const button = this.querySelector('[data-qa-primary]');
      button.dataset.mode = mode;
      const text = this.querySelector('[data-qa-primary-text]');
      const side = this.querySelector('[data-qa-primary-side]');
      if (mode !== 'add') {
        button.classList.remove('is-pop');
        void button.offsetWidth;
        button.classList.add('is-pop');
      }
      if (mode === 'next') {
        text.textContent = `${this.dataset.nextLabel} ${nextPanel.dataset.name}`;
        side.textContent = '→';
      } else if (mode === 'done') {
        text.textContent = `${this.dataset.addedLabel} ✓`;
        side.textContent = '';
      } else {
        text.textContent = this.dataset.addButtonLabel;
      }
      this.#sync(this.#panel());
    }

    #selection(panel) {
      return [...panel.querySelectorAll('[data-option]')].map((fieldset) => {
        return fieldset.querySelector('input:checked')?.value ?? null;
      });
    }

    #resolve(panel) {
      const variants = this.#variants[panel.dataset.id] || [];
      const selection = this.#selection(panel);
      if (selection.includes(null)) return null;
      return variants.find((v) => v.a && selection.every((value, i) => v.o[i] === value)) || null;
    }

    /** Disables sold-out values, then updates the photo, price and button. */
    #sync(panel) {
      if (!panel) return;
      const variants = this.#variants[panel.dataset.id] || [];
      const fieldsets = [...panel.querySelectorAll('[data-option]')];
      const selection = this.#selection(panel);
      for (const [i, fieldset] of fieldsets.entries()) {
        for (const input of fieldset.querySelectorAll('input')) {
          const inStock = variants.some((v) => {
            if (!v.a || v.o[i] !== input.value) return false;
            return selection.every((value, j) => j === i || value === null || v.o[j] === value);
          });
          input.disabled = !inStock;
          if (!inStock && input.checked) input.checked = false;
        }
        const value = fieldset.querySelector('input:checked')?.value ?? '';
        for (const chosen of fieldset.querySelectorAll('[data-chosen]')) chosen.textContent = value;
      }

      const variant = this.#resolve(panel);
      const colorIndex = fieldsets.findIndex((f) => f.classList.contains('sm-dest-sheet__option--color'));
      const color = this.#selection(panel)[colorIndex];
      const picture = variant || variants.find((v) => colorIndex > -1 && v.o[colorIndex] === color);
      const img = panel.querySelector('.sm-dest-qa__img');
      if (img && picture?.img) {
        img.src = picture.img;
        img.removeAttribute('srcset');
      }
      if (variant) panel.querySelector('[data-qa-price]').textContent = this.#money(variant.p);
      if (panel.dataset.qaPanel !== this.#active) return;

      const button = this.querySelector('[data-qa-primary]');
      const hint = this.querySelector('[data-qa-hint]');
      if (this.#mode === 'add') {
        this.querySelector('[data-qa-primary-side]').textContent = variant ? this.#money(variant.p) : '';
        button.disabled = !variant || this.#busy;
        hint.textContent = variant || this.#busy ? '' : this.dataset.chooseLabel;
      } else {
        hint.textContent = '';
        button.disabled = this.#mode === 'done';
      }
    }

    /** Same output as Liquid's money_without_trailing_zeros. */
    #money(cents) {
      const formatMoney = window.theme?.Currency?.formatMoney;
      const format = window.theme?.settings?.moneyFormat;
      const formatted = formatMoney && format ? formatMoney(cents, format) : `$${(cents / 100).toFixed(2)}`;
      return formatted.replace(/[.,]00(?!\d)/, '');
    }

    /** The look's next piece that isn't in the bag yet, after this one. */
    #nextPanel(panel) {
      const pieces = this.#lookPanels(panel);
      const start = pieces.indexOf(panel);
      for (let step = 1; step < pieces.length; step += 1) {
        const candidate = pieces[(start + step) % pieces.length];
        if (!this.#inBag.has(candidate.dataset.qaPanel)) return candidate;
      }
      return null;
    }

    async #add() {
      const panel = this.#panel();
      const variant = panel && this.#resolve(panel);
      if (!variant || this.#busy) return;
      const error = this.querySelector('[data-qa-error]');
      error.textContent = '';
      this.#busy = true;
      this.querySelector('[data-qa-primary]').setAttribute('aria-busy', 'true');
      this.#sync(panel);

      try {
        const response = await fetch(window.theme?.routes?.cartAdd || '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: variant.id, quantity: 1 }] })
        });
        const data = await response.json();
        if (!response.ok) {
          error.textContent = data.description || data.message || this.dataset.errorLabel;
          return;
        }

        const key = panel.dataset.qaPanel;
        this.#inBag.add(key);
        const row = this.querySelector(`[data-piece="${key}"]`);
        row.classList.add('is-in');
        const status = row.querySelector('[data-piece-status]');
        status.textContent = `${this.dataset.inBagLabel} · ${this.#selection(panel).join(' / ')}`;
        status.hidden = false;
        row.querySelector('[data-piece-cta]').textContent = `${this.dataset.inBagLabel} ✓`;
        const rowImg = row.querySelector('.sm-dest-chip__img');
        if (rowImg && variant.img) {
          rowImg.src = variant.img;
          rowImg.removeAttribute('srcset');
        }

        const done = this.querySelector('[data-qa-done]');
        done.textContent = `✓ ${panel.dataset.name} ${this.dataset.addedNote}`;
        this.#progress(panel);

        const zipify = window.Zipify?.Cart?.instance;
        const next = this.#nextPanel(panel);
        if (next) {
          this.#setMode('next', next);
          if (typeof zipify?.updateCart === 'function') zipify.updateCart();
          else document.dispatchEvent(new CustomEvent('cart:build'));
          return;
        }

        this.#setMode('done');
        setTimeout(() => {
          this.#closeSheet();
          if (typeof zipify?.openUpdatedCart === 'function') {
            zipify.openUpdatedCart();
          } else if (window.theme?.settings?.cartType === 'page') {
            window.location.href = window.theme.routes?.cartPage || '/cart';
          } else {
            document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: data.items?.[0] } }));
          }
        }, 700);
      } catch (e) {
        error.textContent = this.dataset.errorLabel;
      } finally {
        this.#busy = false;
        this.querySelector('[data-qa-primary]').removeAttribute('aria-busy');
        this.#sync(panel);
      }
    }
  }

  if (!customElements.get('sm-look-shop')) {
    customElements.define('sm-look-shop', SmLookShop);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sm-dest-pack"] && !Shopify.designMode) return;
  try {
    
  /**
   * Packing list → bag. Packing is one tap; "Review my bag" opens a
   * <dialog> where each packed piece gets its options, and one button
   * adds every piece to the cart in a single request.
   */
  class SmPackList extends HTMLElement {
    #packed = new Set();
    #variants = {};
    #sheet = null;
    #bar = null;
    #busy = false;
    #rowsReady = false;
    #peek = null;
    #peekFrom = null;
    #raf = 0;
    #justPacked = null;
    #lift = -1;

    connectedCallback() {
      try {
        // Compact JSON (snippets/sm-dest-variants-json.liquid): each photo
        // once per product, variants point at it by index; expand to img.
        const raw = JSON.parse(this.querySelector('[data-variants]')?.textContent || '{}');
        this.#variants = Object.fromEntries(Object.entries(raw).map(([id, product]) => [
          id, (product.v || []).map((v) => ({ ...v, img: product.imgs?.[v.i] ?? null })),
        ]));
      } catch (error) {
        this.#variants = {};
      }
      this.#sheet = this.querySelector('[data-sheet]');
      this.#bar = this.querySelector('.sm-dest-pack__bar');
      this.#peek = this.querySelector('[data-peek]');
      window.addEventListener('scroll', this.#onScroll, { passive: true });
      window.addEventListener('resize', this.#onScroll);
      this.addEventListener('click', this.#onClick);
      this.#sheet?.addEventListener('change', this.#onChange);
      this.#sheet?.addEventListener('close', this.#onClose);
      this.#sheet?.addEventListener('cancel', this.#onCancel);
      this.#peek?.addEventListener('cancel', this.#onPeekCancel);
      this.#peek?.addEventListener('close', this.#onPeekClose);
      this.#render();
      this.#onScroll();
    }

    /** Builds the bag rows from their template, once, and syncs them. */
    #ensureRows() {
      if (this.#rowsReady) return;
      this.#rowsReady = true;
      const template = this.querySelector('template[data-sheet-rows]');
      if (!template) return;
      template.replaceWith(template.content.cloneNode(true));
      for (const item of this.querySelectorAll('[data-sheet-item]')) this.#sync(item);
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this.#onScroll);
      window.removeEventListener('resize', this.#onScroll);
      if (this.#raf) cancelAnimationFrame(this.#raf);
      document.documentElement.style.setProperty('--sm-chat-lift', '0px');
      this.removeEventListener('click', this.#onClick);
      this.#sheet?.removeEventListener('change', this.#onChange);
      this.#sheet?.removeEventListener('close', this.#onClose);
      this.#sheet?.removeEventListener('cancel', this.#onCancel);
      this.#peek?.removeEventListener('cancel', this.#onPeekCancel);
      this.#peek?.removeEventListener('close', this.#onPeekClose);
      document.documentElement.classList.remove('sm-dest-sheet-open');
    }

    #onClick = (event) => {
      const target = event.target;
      if (target === this.#peek || target.closest('[data-peek-close]')) {
        this.#closeSheet(this.#peek);
        return;
      }
      const peekOpen = target.closest('[data-peek-open]');
      if (peekOpen) {
        this.#openPeek(peekOpen.closest('[data-sheet-item]'), peekOpen);
        return;
      }
      if (target === this.#sheet) {
        this.#closeSheet();
        return;
      }
      const toggle = target.closest('[data-pack-toggle]');
      if (toggle) {
        this.#toggle(toggle.closest('[data-pack-item]').dataset.id);
        return;
      }
      if (target.closest('[data-review]')) {
        this.#open();
        return;
      }
      if (target.closest('[data-close]')) {
        this.#closeSheet();
        return;
      }
      const remove = target.closest('[data-remove]');
      if (remove) {
        const item = remove.closest('[data-sheet-item]');
        const items = [...this.querySelectorAll('[data-sheet-item]:not([hidden])')];
        const next = items[items.indexOf(item) + 1] || items[items.indexOf(item) - 1];
        this.#toggle(item.dataset.id, false);
        if (!this.#packed.size) {
          this.#closeSheet();
          return;
        }
        (next?.querySelector('[data-remove]') || this.querySelector('[data-close]')).focus();
        return;
      }
      if (target.closest('[data-add]')) this.#add();
    };

    /** Lifts the chat bubble while the bag bar is in the bottom 80px. */
    #onScroll = () => {
      if (this.#raf) return;
      this.#raf = requestAnimationFrame(() => {
        this.#raf = 0;
        const rect = this.#bar && !this.#bar.hidden ? this.#bar.getBoundingClientRect() : null;
        const low = rect && rect.top < innerHeight && rect.bottom > innerHeight - 80;
        const lift = low ? Math.max(0, Math.round(innerHeight - rect.top - 8)) : 0;
        // Only write on change: a root style write restyles the whole page.
        if (lift === this.#lift) return;
        this.#lift = lift;
        document.documentElement.style.setProperty('--sm-chat-lift', `${lift}px`);
      });
    };

    #onChange = (event) => {
      const item = event.target.closest('[data-sheet-item]');
      if (!item) return;
      this.#sync(item);
      this.#render();
    };

    /**
     * Closes with a slide-down instead of vanishing (motion pass,
     * 2026-09-23). Escape is routed here through the cancel event so it
     * animates too. Reduced motion closes at once. Also closes the larger
     * view (`this.#peek`), which fades out instead.
     */
    #closeSheet(sheet = this.#sheet) {
      if (!sheet?.open || sheet.classList.contains('is-closing')) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        sheet.close();
        return;
      }
      sheet.classList.add('is-closing');
      let done = false;
      const finish = (event) => {
        if (done || (event && event.target !== sheet)) return;
        done = true;
        sheet.removeEventListener('animationend', finish);
        sheet.classList.remove('is-closing');
        sheet.close();
      };
      sheet.addEventListener('animationend', finish);
      setTimeout(() => finish(), 400);
    }

    #onCancel = (event) => {
      event.preventDefault();
      this.#closeSheet();
    };

    #onPeekCancel = (event) => {
      event.preventDefault();
      this.#closeSheet(this.#peek);
    };

    #onPeekClose = () => {
      this.#peekFrom?.focus({ preventScroll: true });
      this.#peekFrom = null;
    };

    /**
     * Opens the larger view for a bagged piece: the photo of the colour
     * chosen right now (the 160px sheet image re-requested wider from the
     * CDN), its name, price and colour, and the description from the
     * row's inert template.
     */
    #openPeek(item, trigger) {
      const peek = this.#peek;
      if (!peek || !item || peek.open) return;
      const variants = this.#variants[item.dataset.id] || [];
      const fieldsets = [...item.querySelectorAll('[data-option]')];
      const colorIndex = fieldsets.findIndex((f) => f.classList.contains('sm-dest-sheet__option--color'));
      const selection = this.#selection(item);
      const color = colorIndex > -1 ? selection[colorIndex] : null;
      const variant = this.#resolve(item.dataset.id)
        || variants.find((v) => color !== null && v.o[colorIndex] === color)
        || variants[0];
      const name = item.querySelector('.sm-dest-sheet__name')?.textContent.trim() || '';

      const img = peek.querySelector('[data-peek-img]');
      if (variant?.img) {
        // A different photo stays hidden until it arrives, so the last
        // piece's photo never shows under this one's name. The same photo
        // fires no load event, so it's left alone.
        const src = this.#sized(variant.img, 900);
        if (img.getAttribute('src') !== src) {
          img.classList.add('is-loading');
          const shown = () => img.classList.remove('is-loading');
          img.addEventListener('load', shown, { once: true });
          img.addEventListener('error', shown, { once: true });
        }
        img.srcset = [600, 900, 1200].map((w) => `${this.#sized(variant.img, w)} ${w}w`).join(', ');
        img.src = src;
        img.alt = color ? `${name}, ${color}` : name;
        img.hidden = false;
      } else {
        img.hidden = true;
      }
      peek.querySelector('[data-peek-name]').textContent = name;
      peek.querySelector('[data-peek-price]').textContent = item.querySelector('[data-sheet-price]')?.textContent || '';
      const colorName = colorIndex > -1 ? fieldsets[colorIndex].querySelector('legend')?.firstChild?.textContent.trim() : '';
      peek.querySelector('[data-peek-color]').textContent = color ? `${colorName} · ${color}` : '';
      const desc = peek.querySelector('[data-peek-desc-view]');
      const template = item.querySelector('template[data-peek-desc]');
      desc.replaceChildren(template ? template.content.cloneNode(true) : '');
      desc.scrollTop = 0;

      this.#peekFrom = trigger;
      peek.showModal();
    }

    /** The same Shopify CDN image at another width. */
    #sized(src, width) {
      const url = new URL(src, window.location.href);
      url.searchParams.set('width', width);
      return url.href;
    }

    #onClose = () => {
      document.documentElement.classList.remove('sm-dest-sheet-open');
      // Back to the bag button, or to the list itself once the bag is empty.
      const review = this.querySelector('[data-review]');
      if (this.#packed.size && review) {
        review.focus({ preventScroll: true });
      } else {
        const list = this.closest('.sm-dest-pack');
        if (list && !list.hasAttribute('tabindex')) list.setAttribute('tabindex', '-1');
        list?.focus({ preventScroll: true });
      }
    };

    #toggle(id, force) {
      const on = force ?? !this.#packed.has(id);
      if (on) this.#packed.add(id);
      else this.#packed.delete(id);
      this.#justPacked = on ? id : null;
      this.#render();
      this.#justPacked = null;
      this.#announce();
    }

    #open() {
      if (!this.#packed.size || !this.#sheet) return;
      this.#ensureRows();
      this.#render();
      this.#sheet.showModal();
      document.documentElement.classList.add('sm-dest-sheet-open');
      const firstOpen = [...this.#sheet.querySelectorAll('[data-sheet-item]:not([hidden]) [data-option]')]
        .find((fieldset) => !fieldset.querySelector('input:checked'));
      firstOpen?.querySelector('input:not(:disabled)')?.focus();
    }

    /** Selected value per option index, null where nothing is chosen. */
    #selection(item) {
      return [...item.querySelectorAll('[data-option]')].map((fieldset) => {
        return fieldset.querySelector('input:checked')?.value ?? null;
      });
    }

    /** The available variant matching every chosen option, or null. */
    #resolve(id) {
      const item = this.#sheetItem(id);
      const variants = this.#variants[id] || [];
      if (!item) return null;
      const selection = this.#selection(item);
      if (selection.includes(null)) return null;
      return variants.find((v) => v.a && selection.every((value, i) => v.o[i] === value)) || null;
    }

    /** Disables values with no in-stock variant under the other choices. */
    #sync(item) {
      const variants = this.#variants[item.dataset.id] || [];
      const fieldsets = [...item.querySelectorAll('[data-option]')];
      const selection = this.#selection(item);
      for (const [i, fieldset] of fieldsets.entries()) {
        for (const input of fieldset.querySelectorAll('input')) {
          const inStock = variants.some((v) => {
            if (!v.a || v.o[i] !== input.value) return false;
            return selection.every((value, j) => j === i || value === null || v.o[j] === value);
          });
          input.disabled = !inStock;
          if (!inStock && input.checked) input.checked = false;
        }
        const chosen = fieldset.querySelector('[data-chosen]');
        if (chosen) chosen.textContent = fieldset.querySelector('input:checked')?.value ?? '';
      }

      const variant = this.#resolve(item.dataset.id);
      const colorIndex = fieldsets.findIndex((f) => f.classList.contains('sm-dest-sheet__option--color'));
      const picture = variant || variants.find((v) => colorIndex > -1 && v.o[colorIndex] === this.#selection(item)[colorIndex]);
      const img = item.querySelector('.sm-dest-sheet__img');
      if (img && picture?.img) {
        img.src = picture.img;
        img.removeAttribute('srcset');
      }
      const price = item.querySelector('[data-sheet-price]');
      if (price && variant) price.textContent = this.#money(variant.p);
    }

    #sheetItem(id) {
      return this.querySelector(`[data-sheet-item][data-id="${id}"]`);
    }

    /** Same output as Liquid's money_without_trailing_zeros. */
    #money(cents) {
      const formatMoney = window.theme?.Currency?.formatMoney;
      const format = window.theme?.settings?.moneyFormat;
      const formatted = formatMoney && format ? formatMoney(cents, format) : `$${(cents / 100).toFixed(2)}`;
      return formatted.replace(/[.,]00(?!\d)/, '');
    }

    #price(id) {
      const variant = this.#resolve(id);
      if (variant) return variant.p;
      return Number(this.querySelector(`[data-pack-item][data-id="${id}"]`)?.dataset.price || 0);
    }

    #render() {
      const counts = { t: 0, b: 0, o: 0 };
      let total = 0;
      let ready = 0;
      const thumbs = [];

      for (const item of this.querySelectorAll('[data-pack-item]')) {
        const on = this.#packed.has(item.dataset.id);
        item.classList.toggle('is-packed', on);
        const toggle = item.querySelector('[data-pack-toggle]');
        toggle.setAttribute('aria-pressed', String(on));
      }

      for (const id of this.#packed) {
        const item = this.querySelector(`[data-pack-item][data-id="${id}"]`);
        if (!item) continue;
        const kind = item.dataset.kind;
        if (kind in counts) counts[kind] += 1;
        total += this.#price(id);
        if (this.#resolve(id)) ready += 1;
        const thumb = item.querySelector('.sm-dest-pack__thumb-img');
        const src = thumb?.currentSrc || thumb?.src;
        if (src) thumbs.push({ src, id });
      }

      for (const item of this.querySelectorAll('[data-sheet-item]')) {
        item.hidden = !this.#packed.has(item.dataset.id);
        item.classList.toggle('needs-choice', !item.hidden && !this.#resolve(item.dataset.id));
      }

      const count = this.#packed.size;
      const outfits = counts.t * counts.b + counts.o;
      const offerMin = Number(this.dataset.offerMin || 0);
      const offerPercent = Number(this.dataset.offerPercent || 0);
      const saving = offerMin && count >= offerMin ? Math.round((total * offerPercent) / 100) : 0;
      const totalText = saving
        ? `<s>${this.#money(total)}</s> ${this.#money(total - saving)}`
        : count ? this.#money(total) : '';

      const caseEl = this.querySelector('[data-case]');
      caseEl.replaceChildren(...thumbs.slice(0, 6).map(({ src, id }) => {
        const img = document.createElement('img');
        if (id === this.#justPacked) img.className = 'is-new';
        img.src = src;
        img.alt = '';
        img.width = 30;
        img.height = 30;
        return img;
      }));
      if (thumbs.length > 6) {
        const more = document.createElement('span');
        more.textContent = `+${thumbs.length - 6}`;
        caseEl.append(more);
      }
      const outfitsEl = this.querySelector('[data-outfits]');
      if (outfitsEl.textContent !== String(outfits)) {
        outfitsEl.textContent = outfits;
        outfitsEl.classList.remove('is-bump');
        void outfitsEl.offsetWidth;
        outfitsEl.classList.add('is-bump');
      }
      // No bag until the first piece is packed (Alex: no empty placeholder).
      this.querySelector('[data-bar]').hidden = count === 0;
      this.#onScroll();
      this.querySelector('[data-review-main]').textContent = `${this.dataset.reviewLabel} (${count})`;
      this.querySelector('[data-total]').innerHTML = totalText;
      this.querySelector('[data-review]').disabled = count === 0;

      const note = this.querySelector('[data-offer-note]');
      if (note) {
        note.textContent = saving
          ? `−${this.#money(saving)}`
          : (this.dataset.offerProgress || '').replace('[count]', String(Math.max(offerMin - count, 0)));
      }

      const progress = this.querySelector('[data-progress]');
      if (progress) {
        progress.textContent = (this.dataset.progressLabel || '')
          .replace('[ready]', String(ready))
          .replace('[total]', String(count));
      }
      const add = this.querySelector('[data-add]');
      add.disabled = this.#busy || count === 0 || ready < count;
      this.querySelector('[data-sheet-total]').innerHTML = totalText;
    }

    #announce() {
      const status = this.querySelector('[data-status]');
      if (!status) return;
      const outfits = this.querySelector('[data-outfits]').textContent;
      status.textContent = '';
      requestAnimationFrame(() => {
        status.textContent = `${this.#packed.size} ${this.dataset.piecesLabel}, ${outfits} ${this.dataset.outfitsLabel}`;
      });
    }

    async #add() {
      const items = [...this.#packed].map((id) => this.#resolve(id)).filter(Boolean).map((v) => ({ id: v.id, quantity: 1 }));
      if (!items.length || items.length < this.#packed.size) return;
      const error = this.querySelector('[data-error]');
      const button = this.querySelector('[data-add]');
      error.hidden = true;
      this.#busy = true;
      button.classList.add('is-loading');
      button.setAttribute('aria-busy', 'true');
      this.#render();

      try {
        const response = await fetch(window.theme?.routes?.cartAdd || '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items })
        });
        const data = await response.json();
        if (!response.ok) {
          error.textContent = data.description || data.message || this.dataset.errorLabel;
          error.hidden = false;
          return;
        }
        this.#closeSheet();
        this.#packed.clear();
        if (window.theme?.settings?.cartType === 'page') {
          window.location.href = window.theme.routes?.cartPage || '/cart';
          return;
        }
        const zipify = window.Zipify?.Cart?.instance;
        if (typeof zipify?.openUpdatedCart === 'function') {
          zipify.openUpdatedCart();
        } else {
          document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: data.items?.[0] } }));
        }
      } catch (e) {
        error.textContent = this.dataset.errorLabel;
        error.hidden = false;
      } finally {
        this.#busy = false;
        button.classList.remove('is-loading');
        button.removeAttribute('aria-busy');
        this.#render();
      }
    }
  }

  if (!customElements.get('sm-pack-list')) {
    customElements.define('sm-pack-list', SmPackList);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sm-going-somewhere"] && !Shopify.designMode) return;
  try {
    
  /**
   * Luggage tags: pressed state on touch (iOS Safari never applies
   * :active to a plain link) and a departing state once one is followed,
   * held until the next page takes over. A page restored from the
   * back/forward cache comes back without it.
   */
  (() => {
    const release = () => {
      for (const item of document.querySelectorAll('.sm-gs__item.is-pressed')) item.classList.remove('is-pressed');
    };
    document.addEventListener('pointerdown', (event) => {
      if (!event.isPrimary) return;
      event.target.closest?.('.sm-gs__item')?.classList.add('is-pressed');
    }, { passive: true });
    for (const type of ['pointerup', 'pointercancel', 'dragstart']) {
      document.addEventListener(type, release, { passive: true });
    }
    document.addEventListener('click', (event) => {
      const tag = event.target.closest?.('.sm-gs__tag');
      if (!tag || event.defaultPrevented || event.button !== 0) return;
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const row = tag.closest('.sm-gs__row');
      const item = tag.closest('.sm-gs__item');
      row?.classList.add('is-departing');
      item?.classList.add('is-departing');
      // If the page change stalls or never happens, don't leave it held.
      setTimeout(() => {
        row?.classList.remove('is-departing');
        item?.classList.remove('is-departing');
      }, 5000);
    });
    window.addEventListener('pageshow', (event) => {
      if (!event.persisted) return;
      for (const el of document.querySelectorAll('.sm-gs .is-departing')) el.classList.remove('is-departing');
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sm-new-noteworthy"] && !Shopify.designMode) return;
  try {
    
  /**
   * sm-magazine — turns [data-page] elements like magazine pages.
   *
   * Pages are stacked, page 1 on top. Turning a page rotates it -180deg
   * around its left edge (backface hidden), revealing the next one. A drag
   * rotates the page with the finger; releasing past 30% of the width
   * completes the turn, otherwise it settles back. Dragging right brings
   * the previous page back over.
   *
   * Taps still reach the page links: pointer capture only starts once the
   * gesture locks horizontal, and the click that ends a drag is swallowed.
   * Vertical gestures are left to the page (touch-action: pan-y). Pages
   * that aren't showing are `inert`, so only the visible page is in the
   * tab order and the accessibility tree. Reduced motion turns instantly.
   */
  class SmMagazine extends HTMLElement {
    #pages = [];
    #stage = null;
    #index = 0;
    #drag = null;
    #dragged = false;
    #reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

    connectedCallback() {
      this.#stage = this.querySelector('[data-stage]');
      this.#pages = [...this.querySelectorAll('[data-page]')];
      if (!this.#stage || this.#pages.length < 2) return;

      this.#stage.addEventListener('pointerdown', this.#onDown);
      this.#stage.addEventListener('pointermove', this.#onMove);
      this.#stage.addEventListener('pointerup', this.#onUp);
      this.#stage.addEventListener('pointercancel', this.#onUp);
      this.#stage.addEventListener('click', this.#onClick, true);
      this.#stage.addEventListener('dragstart', this.#onDragStart);
      this.addEventListener('keydown', this.#onKey);
      this.querySelector('[data-prev]')?.addEventListener('click', () => this.go(this.#index - 1));
      this.querySelector('[data-next]')?.addEventListener('click', () => this.go(this.#index + 1));
      this.#render(0);
    }

    disconnectedCallback() {
      this.#stage?.removeEventListener('pointerdown', this.#onDown);
      this.#stage?.removeEventListener('pointermove', this.#onMove);
      this.#stage?.removeEventListener('pointerup', this.#onUp);
      this.#stage?.removeEventListener('pointercancel', this.#onUp);
      this.#stage?.removeEventListener('click', this.#onClick, true);
      this.#stage?.removeEventListener('dragstart', this.#onDragStart);
      this.removeEventListener('keydown', this.#onKey);
    }

    go(to, duration = 600, ease = 'cubic-bezier(.4,0,.2,1)') {
      this.#index = Math.max(0, Math.min(this.#pages.length - 1, to));
      this.#render(this.#reduce.matches ? 0 : duration, ease);
    }

    /**
     * Pages more than one away from the current one get .is-far (not
     * rendered), so their photos only download as the reader nears them.
     * Focus on a page link follows the turn, since the old page goes inert;
     * the end arrows use aria-disabled so they keep focus (go() clamps).
     */
    #render(duration, ease) {
      const last = this.#pages.length - 1;
      const hadFocus = this.#stage.contains(document.activeElement);
      for (const [i, page] of this.#pages.entries()) {
        this.#set(page, i < this.#index ? -180 : 0, duration, ease);
        page.style.setProperty('--sm-nn-shade', 0);
        page.inert = i !== this.#index;
        page.classList.toggle('is-far', Math.abs(i - this.#index) > 1);
      }
      if (hadFocus) this.#pages[this.#index].querySelector('a')?.focus({ preventScroll: true });
      const current = this.querySelector('[data-current]');
      if (current) current.textContent = String(this.#index + 1).padStart(2, '0');
      const prev = this.querySelector('[data-prev]');
      const next = this.querySelector('[data-next]');
      if (prev) prev.setAttribute('aria-disabled', String(this.#index === 0));
      if (next) next.setAttribute('aria-disabled', String(this.#index === last));
    }

    /** --sm-nn-turn lets the page's shade fade over the same time. */
    #set(page, angle, duration, ease = 'cubic-bezier(.22,.7,.2,1)') {
      page.style.transition = duration ? `transform ${duration}ms ${ease}` : 'none';
      page.style.setProperty('--sm-nn-turn', `${duration}ms`);
      page.style.transform = `rotateY(${angle}deg)`;
    }

    #onDown = (event) => {
      if (event.button !== 0) return;
      this.#drag = { x: event.clientX, y: event.clientY, dx: 0, lock: null, id: event.pointerId };
      this.#dragged = false;
      this.#stage.classList.add('is-pressed');
    };

    #onMove = (event) => {
      const drag = this.#drag;
      if (!drag) return;
      const dx = event.clientX - drag.x;
      const dy = event.clientY - drag.y;
      if (drag.lock === null && (Math.abs(dx) > 6 || Math.abs(dy) > 6)) {
        drag.lock = Math.abs(dx) > Math.abs(dy) ? 'x' : 'y';
        this.#stage.classList.remove('is-pressed');
        if (drag.lock === 'x') {
          this.#dragged = true;
          this.#stage.setPointerCapture(drag.id);
        }
      }
      if (drag.lock !== 'x') return;
      drag.dx = dx;
      if (this.#reduce.matches) return;

      const width = this.#stage.clientWidth || 1;
      const progress = Math.max(-1, Math.min(1, dx / width));
      if (dx < 0 && this.#index < this.#pages.length - 1) {
        const page = this.#pages[this.#index];
        this.#pages[this.#index + 1].inert = false;
        this.#set(page, progress * 180, 0);
        page.style.setProperty('--sm-nn-shade', Math.abs(progress) * 0.9);
      } else if (dx > 0 && this.#index > 0) {
        const page = this.#pages[this.#index - 1];
        page.inert = false;
        this.#set(page, -180 + progress * 180, 0);
        page.style.setProperty('--sm-nn-shade', (1 - progress) * 0.9);
      }
    };

    /**
     * A released swipe finishes over the distance it has left, already
     * moving, so it decelerates: 490ms from 30% down to 280ms from 90%.
     * A short swipe settles back in 200-320ms (motion pass, 2026-09-24).
     */
    #onUp = () => {
      this.#stage.classList.remove('is-pressed');
      const drag = this.#drag;
      this.#drag = null;
      if (!drag || drag.lock !== 'x') return;
      const width = this.#stage.clientWidth || 1;
      const moved = Math.min(1, Math.abs(drag.dx) / width);
      const out = 'cubic-bezier(.22,.7,.2,1)';
      if (drag.dx < -width * 0.3) this.go(this.#index + 1, 240 + 360 * (1 - moved), out);
      else if (drag.dx > width * 0.3) this.go(this.#index - 1, 240 + 360 * (1 - moved), out);
      else this.#render(this.#reduce.matches ? 0 : 200 + 400 * moved, out);
    };

    #onClick = (event) => {
      if (!this.#dragged) return;
      event.preventDefault();
      event.stopPropagation();
      this.#dragged = false;
    };

    #onDragStart = (event) => event.preventDefault();

    #onKey = (event) => {
      if (event.key === 'ArrowLeft') this.go(this.#index - 1);
      else if (event.key === 'ArrowRight') this.go(this.#index + 1);
    };
  }

  if (!customElements.get('sm-magazine')) {
    customElements.define('sm-magazine', SmMagazine);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sm-size-fit"] && !Shopify.designMode) return;
  try {
    
  /* Chat with us: Chatra's queue stub (sm-chat-setup) is defined before
     any of this runs, so the call is safe before their script arrives.
     smChatraNow skips the loader's idle + 3s wait, which is right for a
     first touch anywhere but too slow for a tap on a chat button. */
  document.addEventListener('click', (event) => {
    if (!event.target.closest('[data-sm-open-chat]')) return;
    if (typeof window.Chatra !== 'function') return;
    if (typeof window.smChatraNow === 'function') window.smChatraNow();
    window.Chatra('openChat', true);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sm-travel-edit"] && !Shopify.designMode) return;
  try {
    
  /**
   * The Boarded stamp (Alex picked it, 2026-09-24) carries today's date,
   * written in on the tap: Shopify caches the page, so a Liquid date would
   * go stale. Capture phase, so it lands before sm-press.js shows the stamp.
   */
  document.addEventListener('click', (event) => {
    const date = event.target.closest?.('.sm-travel-edit__ticket')?.querySelector('[data-stamp-date]');
    if (!date) return;
    const now = new Date();
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    date.textContent = `${String(now.getDate()).padStart(2, '0')} ${months[now.getMonth()]} ${String(now.getFullYear()).slice(-2)}`;
  }, true);

  /**
   * Moves the active dot as the ticket row scrolls. Scroll progress
   * (0..1) maps to a dot index, so the last dot lights when the row
   * reaches its end even though the last ticket can't scroll to the
   * left edge. Passive listener, one update per frame.
   */
  class SmTravelEditRow extends HTMLElement {
    #row = null;
    #dots = [];
    #raf = 0;
    #observer = null;
    #onScroll = () => {
      if (!this.#raf) this.#raf = requestAnimationFrame(() => this.#update());
    };

    connectedCallback() {
      this.#row = this.querySelector('.sm-travel-edit__row');
      this.#dots = [...this.querySelectorAll('.sm-travel-edit__dot')];
      if (!this.#row || this.#dots.length < 2) return;
      this.#row.addEventListener('scroll', this.#onScroll, { passive: true });
      this.#observer = new ResizeObserver(this.#onScroll);
      this.#observer.observe(this.#row);
      this.#update();
    }

    disconnectedCallback() {
      this.#row?.removeEventListener('scroll', this.#onScroll);
      this.#observer?.disconnect();
      if (this.#raf) cancelAnimationFrame(this.#raf);
    }

    #update() {
      this.#raf = 0;
      const max = this.#row.scrollWidth - this.#row.clientWidth;
      this.toggleAttribute('data-static', max <= 1);
      const progress = max > 1 ? this.#row.scrollLeft / max : 0;
      const active = Math.round(progress * (this.#dots.length - 1));
      for (const [i, dot] of this.#dots.entries()) {
        dot.classList.toggle('is-active', i === active);
      }
    }
  }

  if (!customElements.get('sm-travel-edit-row')) {
    customElements.define('sm-travel-edit-row', SmTravelEditRow);
  }

  } catch(e) { console.error(e); }
})();
})();
